import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type DocumentationBreakpoint = 'compact' | 'narrow' | 'medium' | 'wide';

export const COMPACT_QUERY = '@media (max-width:749.95px)';
export const NARROW_QUERY = '@media (max-width:999.95px)';

export const useDocumentationBreakpoint = (): DocumentationBreakpoint => {
  const theme = useTheme();
  const isCompact = useMediaQuery(COMPACT_QUERY);
  const isNarrow = useMediaQuery(NARROW_QUERY);
  const isMedium = useMediaQuery(theme.breakpoints.down('lg'));

  if (isCompact) {
    return 'compact';
  }
  if (isNarrow) {
    return 'narrow';
  }
  if (isMedium) {
    return 'medium';
  }
  return 'wide';
};
